import { API_ROUTE_ADMIN_ASSETS_NEW } from '@/resources/api-routes'
import { del } from '@/util/auth'

const IS_NEW_BACKEND_API = true
export async function deleteAsset(id: number) {
  return del(`${API_ROUTE_ADMIN_ASSETS_NEW}/${id}`, IS_NEW_BACKEND_API)
}
